import { Store } from '../types/api/entities/store';

export function formatTitle(store: Store, title?: string) {
  return title ? `${title} - ${store.name}` : store.name;
}
